<template>
  <div class="app-main">
    <router-view/>
  </div>
</template>
<script>
export default {
  name: 'AppMain'
}
</script>
<style lang="less" scoped>
.app-main {
  padding: 10px;
  height: 100%;
  box-sizing: border-box;
  background-color: #ECF0F5;
  position: absolute;
  right: 0;
  left: 220px;
  top: 0;
  overflow-y:auto;
  overflow-x:auto;

  &>div{
    border: 1px solid #E4E7ED;
    padding: 10px;
    box-sizing: border-box;
    background-color: #ffffff;
    min-height: 400px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue